import { useSelector } from "react-redux";
import BlitzLogo from "../../assets/images/blitz_logo.svg";

const BLITZ_POC = {
  email: "tracking@blitznow.in",
  contactNumber: "+91 8035316943",
};

export const useWhitelisting = () => {
  const { company_name, logo, orgID, loading, tracking_page_details } = useSelector(
    state => state.companyInfoReducer
  );

  const isWhitelisted = tracking_page_details ? true : false;

  // tracking_page_details can hold only map icons (home/rider/store) with no
  // branding, so fall back field by field rather than trusting its presence.
  const pocInfo = {
    email: (isWhitelisted && tracking_page_details?.contact_email) || BLITZ_POC.email,
    contactNumber: (isWhitelisted && tracking_page_details?.contact_number) || BLITZ_POC.contactNumber,
  };

  return {
    company_name,
    logo,
    isWhitelisted,
    pocInfo,
    loading,
    trackingPageLogo: tracking_page_details?.logo || logo || BlitzLogo,
  };
};
